import { useState, useContext } from 'react';
import { CurrProfileContext } from '../App/App.tsx';
import { TextField, Button, Typography, Grid, Box, Paper, } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient.js';

function SignUp() {
  const nav = useNavigate();
  const [formData, setFormData] = useState({ username: '', email: '', password: '', });
  const { _p, _set, updateProfile } = useContext(CurrProfileContext);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    supabase.auth.signUp({ 
      email: formData.email, 
      password: formData.password 
    }).then((res) => {
      if(res.error) {
        console.error("Failed to sign up: " + res.error.message)
      } else {
        supabase.from("profiles").insert({ 
          "username": formData.username, 
          "display_name": formData.username
        }).then((res) => {
          if(res.error) {
            console.log("VERY BAD FAILURE OF LOGIN CREATE PROFILE: " + res.error.message)
            alert("Something went very wrong during your sign up... Please contact our support team... (thanks)")
          } else {
            updateProfile();
            nav("/profile")
          }
        })
      }
    })
  };


  
  return (
    <Grid container sx={{ flex: '1', width: '100%', margin: 'auto' }} >
      <Paper elevation={10} sx={{ height: '100%', width: '100%', margin: '0 4vw' }} >
        <Box sx={{
          mt: 4, mb: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
          <Typography component="h1" variant="h4" sx={{ mt: 0}}>
            Sign Up
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ flex: '1', mt: 3, pl: 4, pr: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={20} style={{ width: '100%' }}>
                <TextField required fullWidth
                  id="username" label="Username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={20} style={{ width: '100%'}}>
                <TextField required fullWidth
                  id="email" label="Email Address"
                  name="email" type="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={20} style={{ width: '100%'}}>
                <TextField required fullWidth
                  name="password" label="Password"
                  type="password" id="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>

            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2, mb: 2 }}>
              Sign Up
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item    sx={{ mb: 2 }}>
                <Link to="/sign_in" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box> 
      </Paper>
    </Grid>
  );
}
export default SignUp;